
import Navigation from '../../components/feature/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import BrandSection from './components/BrandSection';
import ServiceSection from './components/ServiceSection';
import FeedbackSection from './components/FeedbackSection';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <HeroSection />
      <AboutSection />
      <BrandSection />
      <ServiceSection />
      <FeedbackSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
